class ConfigItemController extends AbstractController
  @$inject = [ '$injector', '$timeout', 'pathService', 'configItemService' ]
  constructor: (injector, @timeout, pathService, @configItemService) ->
    super(injector)
    @loadingTracker = @promiseTracker()
    @submitTracker = @promiseTracker()

    @filtro = {
      module: undefined,
      resource: undefined,
      resourceId: undefined
    }

    @values = {}
    @listOfConfigItem = []
    @config = {}
    @listOfResource = []

  init: (module, resource, resourceId) ->

    @filtro.module = module
    @filtro.resource = resource
    @filtro.resourceId = resourceId

    if !@filtro.resource and @filtro.module
      @loadingTracker.addPromise @configItemService.getResources @filtro.module, (data) =>
        @listOfResource = data

    @consultar()

  consultar: ->
    @listOfConfigItem = []

    if @filtro.resource
      @loadingTracker.addPromise @configItemService.getConfigs [ @filtro ], (data) =>
        for resourceKey, resource of data
          for key, config of resource
            item = config[@filtro.resourceId || 'default']

            @config[key] = item
            @listOfConfigItem.push(item)

  convertToBase64: (config, input) ->
    files = input.files;
    if (files.length > 0)

      fileToLoad = filesSelected[0];
      fileReader = new FileReader();

      fileReader.onload(fileLoadedEvent) =>
        config = fileLoadedEvent.target.result

      fileReader.readAsDataURL(fileToLoad);

  salvar: (event) ->
    if @listOfConfigItem.length != 0
      if @filtro.resourceId
        for configItem in @listOfConfigItem
          if !configItem.resourceId
            configItem.id = undefined
            configItem.resourceId = @filtro.resourceId

      @submitTracker.addPromise @configItemService.saveConfigs(@listOfConfigItem, (data) =>
        if data.success
          @Alert.success('Configurações salvas!', 'Sucesso')
          @consultar()
        else
          @Alert.error('Erro ao salvar configurações!', 'Erro')
      , event, 'Salvando...')

  hasListFilter: (item) ->
    item.list?

angular.module('eficienciaFiscalModule').controller('configItemController', ConfigItemController)
